import { ThemedButton, Price } from '../../../../components'
import {
  Box,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@elphasecure/elpha-design-system'
import { Check } from '../../../../assets/svgs'

export const Confirmation = ({ policyData, isLoading, paymentData }) => {
  const Icon = ({ enabled }) => {
    return (
      <ListItemIcon sx={{ minWidth: '2.8rem' }}>
        <Box
          component="span"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '2.0rem',
            height: '2.0rem',
            borderRadius: '9999px',
            backgroundColor: enabled ? 'success.main' : 'error.main',
          }}
        >
          <Check />
        </Box>
      </ListItemIcon>
    )
  }

  return (
    <>
      <Box sx={{ marginBottom: '5.6rem', textAlign: 'center' }}>
        <Stack>
          {!isLoading && (
            <Typography
              component="h2"
              variant="bodyMedium"
              sx={{
                marginBottom: '0.4rem',
                color: 'primary.main',
                fontWeight: 'medium',
              }}
            >
              {policyData?.quote_limit >= 1000000
                ? `$${String(policyData?.quote_limit).charAt(
                    0
                  )}M Limit Policy Paid`
                : `$${String(policyData?.quote_limit).charAt(
                    0
                  )}00K Limit Policy Paid`}
              {paymentData?.gross_amount && (
                <Price
                  amount={
                    paymentData?.gross_amount + paymentData?.details?.stripe_fee
                  }
                  term="year"
                />
              )}
            </Typography>
          )}
        </Stack>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          variant="bodyXLarge"
          component="h2"
          sx={{
            fontWeight: '700',
            color: 'primary.600',
            marginBottom: '2.0rem',
          }}
        >
          Here's what comes next for Elpha Secure software users
        </Typography>
        <Stack direction="row" spacing="8.0rem" sx={{ marginBottom: '4.0rem' }}>
          <ListItem disableGutters>
            <Icon enabled={true} />
            <ListItemText
              sx={{ width: '25.1rem' }}
              primary={
                <Typography
                  variant="bodyMedium"
                  sx={{
                    color: 'primary.400',
                    width: '25.1rem',
                  }}
                >
                  Open your email invite to create an Elpha Secure account.
                </Typography>
              }
            />
          </ListItem>
          <ListItem disableGutters>
            <Icon enabled={true} />
            <ListItemText
              sx={{ width: '25.1rem' }}
              primary={
                <Typography
                  variant="bodyMedium"
                  sx={{
                    color: 'primary.400',
                    width: '25.1rem',
                  }}
                >
                  Follow the onboarding steps to install your cybersecurity
                  software.
                </Typography>
              }
            />
          </ListItem>
          <ListItem disableGutters>
            <Icon enabled={true} />
            <ListItemText
              sx={{ width: '25.1rem' }}
              primary={
                <Typography
                  variant="bodyMedium"
                  sx={{
                    color: 'primary.400',
                    width: '25.1rem',
                  }}
                >
                  Access your issued policy document through your broker.
                </Typography>
              }
            />
          </ListItem>
        </Stack>
      </Box>
      <Stack direction="row" spacing="2rem" sx={{ justifyContent: 'center' }}>
        <Link href="https://mail.google.com" target="_blank">
          <ThemedButton variant="outlined" size="small">
            Open Gmail
          </ThemedButton>
        </Link>
        <Link href="https://www.icloud.com/mail" target="_blank">
          <ThemedButton variant="outlined" size="small">
            Open Apple Mail
          </ThemedButton>
        </Link>
        <Link href="https://outlook.live.com/owa/" target="_blank">
          <ThemedButton variant="outlined" size="small">
            Open Outlook
          </ThemedButton>
        </Link>
      </Stack>
    </>
  )
}
